<app-modal-shell [config]="modalConfig">
  <form modal-content [formGroup]="form" class="transfer-form transfer-content" (ngSubmit)="onConfirm()">
    <p class="dialog-subtitle">
      <strong>{{ data.person.firstName }} {{ data.person.lastName }}</strong>
      <span>pasa desde {{ data.person.communityName }} a otra comunidad.</span>
    </p>

    <app-date-picker
      class="full-width"
      label="Fecha efectiva"
      formControlName="effectiveDate"
      [min]="minDate"
      [errorMessages]="{
        required: 'La fecha efectiva es requerida.',
        matDatepickerParse: 'Ingresa una fecha valida.',
        matDatepickerMin: 'La fecha no puede ser anterior a la fecha de nacimiento.'
      }">
    </app-date-picker>

    <app-unit-selector
      class="full-width"
      label="Nueva comunidad"
      [required]="true"
      [unitSource]="allCommunities"
      [groupByLevel]="true"
      groupByMode="ancestors"
      [loading]="isLoadingCommunities"
      formControlName="targetUnitId"
      (unitSelected)="onCommunitySelected($event)">
    </app-unit-selector>

    <mat-form-field class="full-width">
      <mat-label>Motivo <span class="optional-hint">(opcional)</span></mat-label>
      <textarea matInput formControlName="reason" rows="2" maxlength="300"></textarea>
      <mat-hint align="end">{{ form.get('reason')?.value?.length || 0 }}/300</mat-hint>
    </mat-form-field>

    <div class="ministry-transfer-banner" *ngIf="movesMinistryActivityWithCommunity">
      <mat-icon>volunteer_activism</mat-icon>
      <p>
        El miembro ejerce su ministerio en <strong>{{ data.person.communityName }}</strong>.
        Al confirmar, su actividad ministerial también se trasladará a la nueva comunidad en la misma fecha.
      </p>
    </div>

    <div class="summary-banner" *ngIf="selectedCommunity">
      <mat-icon>info</mat-icon>
      <p>
        Se cerrarán los encargos, nombramientos y colaboraciones activos en
        <strong>{{ data.person.communityName }}</strong>. El miembro quedará registrado en
        <strong>{{ selectedCommunity.name }}</strong>.
      </p>
    </div>
  </form>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="onConfirm()">
      Confirmar pase
    </button>
  </ng-container>
</app-modal-shell>
